export const WHITE = '#ffffff';
export const GREY = '#f0f4f7';
export const RED = '#EB5757';
export const GREEN = '#08BD80';
export const BLUE = '#DDE6ED';
export const LIGHTBLUE = '#2D81F7';
export const DARKBLUE = '#3C4852';
export const HALF_GREY = '#E6E6E6';
export const DARK_GREY = '#8FA3B2';
export const ORANGE = '#FFAD3B';
export const DISABLED = '#9AAFBF';
